<template>
  <div id="app">
    <nav class="navbar navbar-expand-lg navbar-light bg-light">
      <div class="container-fluid">
        <img :src="logoUrl" style="width: 3em;padding: 5px; margin-right: 10px;">
        <router-link class="navbar-brand" to="/">PLIC</router-link>
        <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent"
                aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
          <span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse" id="navbarSupportedContent">
          <ul class="navbar-nav me-auto mb-2 mb-lg-0">
            <li class="nav-item">
              <router-link class="nav-link" :class="{ active: $route.path === '/navigation' }" to="/navigation">
                Navigation
              </router-link>
            </li>
            <li class="nav-item">
              <router-link class="nav-link" :class="{ active: $route.path === '/structures' }" to="/structures">
                List
              </router-link>
            </li>
            <li class="nav-item">
              <router-link class="nav-link" :class="{ active: $route.path === '/tools/renumber' }" to="/tools/renumber">
                Tools
              </router-link>
            </li>
            <li class="nav-item">
              <router-link class="nav-link" :class="{ active: $route.path === '/about' }" to="/about">
                About us
              </router-link>
            </li>
            <!-- Admin menu hidden for now
            <li class="nav-item dropdown">
              <a class="nav-link dropdown-toggle" href="#" id="adminDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                Admin
              </a>
              <ul class="dropdown-menu" aria-labelledby="adminDropdown">
                <li>
                  <router-link class="dropdown-item" :class="{ active: $route.path === '/admin/structures' }" to="/admin/structures">
                    <i class="bi bi-building"></i> Structures
                  </router-link>
                </li>
                <li>
                  <router-link class="dropdown-item" :class="{ active: $route.path === '/admin/tags' }" to="/admin/tags">
                    <i class="bi bi-tags"></i> Tags
                  </router-link>
                </li>
                <li>
                  <router-link class="dropdown-item" :class="{ active: $route.path === '/admin/analytics' }" to="/admin/analytics">
                    <i class="bi bi-graph-up"></i> Analytics
                  </router-link>
                </li>
              </ul>
            </li>
            -->
          </ul>
          <form class="d-flex" @submit.prevent="handleSearch">
            <input class="form-control me-2" type="search" placeholder="Search" aria-label="Search" v-model="searchQuery">
            <button class="btn btn-outline-info" type="submit">Search</button>
          </form>
        </div>
      </div>
    </nav>

    <div class="container-fluid p-5">
      <router-view />
    </div>

    <footer class="fixed-bottom bg-light">
      <div class="text-left text-muted">
        <img :src="logoUrl" style="width: 1.8em;padding: 3px;margin-left: 5px;">
        © 2018-2025 Copyright:
        <a href="http://iephb.ru/en/"> IEPHB RAS</a>
      </div>
    </footer>
  </div>
</template>

<script>
const logoUrl = '/logo.svg'

export default {
  name: 'App',
  data() {
    return {
      searchQuery: '',
      logoUrl
    }
  },
  methods: {
    handleSearch() {
      if (this.searchQuery.trim()) {
        this.$router.push({ path: '/structures', query: { search: this.searchQuery } })
      }
    }
  }
}
</script>
